module.exports = __webpack_public_path__ + "img/丽江3_1.dd0eb77c.jpg";